import React from 'react';
import {Constants} from '../helpers';

const Signin = React.lazy(() => import('./SignInUser'));
const GoogleSignUpComplete = React.lazy(() =>
  import('./Auths/GoogleSignUpComplete'),
);
const ForgotPasswordUser = React.lazy(() => import('./ForgotPasswordUser'));
const ResetPasswordUser = React.lazy(() => import('./ResetPasswordUser'));
const Team = React.lazy(() => import('./Team'));
const CreatePasswordUser = React.lazy(() => import('./CreatePasswordUser'));
const Customer360 = React.lazy(() => import('./Customer360'));

const Dashboard = React.lazy(() => import('./Dashboard'));
const QuickActions = React.lazy(() => import('./QuickActions'));
const QuickActionsExisting = React.lazy(() =>
  import('./QuickActions/Existing'),
);
const AMLScreening = React.lazy(() => import('./AMLScreening'));
const AMLScreeningResult = React.lazy(() =>
  import('./AMLScreening/AMLScreeningResult'),
);
const EasyLookup = React.lazy(() => import('./EasyLookup'));
const IndividualLookup = React.lazy(() =>
  import('./EasyLookup/IndividualLookup'),
);
const EasyConnect = React.lazy(() => import('./EasyConnect'));
const EasyOnboard = React.lazy(() => import('./EasyOnboard'));
const FraudDetectionOverview = React.lazy(() =>
  import('./FraudDetection/Overview'),
);
const CustomLists = React.lazy(() =>
  import('./FraudDetection/CustomLists'),
);
const CustomListsItems = React.lazy(() =>
  import('./FraudDetection/CustomLists/CustomListsItems'),
);
const FraudDetectionOverviewPendingCases = React.lazy(() =>
  import('./FraudDetection/Overview/PendingCases'),
);
const FraudDetectionFlows = React.lazy(() =>
  import('./FraudDetection/Flows'),
);
const FraudDetectionFlowsAnalysis = React.lazy(() =>
  import('./FraudDetection/Flows/Analysis'),
);
const FraudDetectionFlowsCases = React.lazy(() =>
  import('./FraudDetection/Flows/Cases'),
);
const FraudDetectionFlowsCasesDetails = React.lazy(() =>
  import('./FraudDetection/Flows/Cases/CasesDetails'),
);
const FraudDetectionFlowsEventDetails = React.lazy(() =>
  import('./FraudDetection/Flows/Events/EventDetails'),
);
const FraudDetectionFlowsEventEvaluationResult = React.lazy(() =>
  import('./FraudDetection/Flows/Events/EvaluationResult'),
);
const FraudDetectionFlowsBehaviouralAnalysis = React.lazy(() =>
  import('./FraudDetection/Flows/Cases/BehaviouralAnalysis'),
);
const FraudDetectionFlowsSupportingDoc = React.lazy(() =>
  import('./FraudDetection/Flows/Cases/SupportingDoc'),
);
const FraudDetectionFlowsEvents = React.lazy(() =>
  import('./FraudDetection/Flows/Events'),
);
const FraudDetectionFlowsAccount = React.lazy(() =>
  import('./FraudDetection/Flows/Account'),
);
const FraudDetectionFlowsAccountTransactions = React.lazy(() =>
  import('./FraudDetection/Flows/Account/AccountTransactions'),
);
const FraudDetectionFlowsSettings = React.lazy(() =>
  import('./FraudDetection/Flows/Settings'),
);
const EasyOnboardCreateFlow = React.lazy(() =>
  import('./EasyOnboard/CreateFlow'),
);
const EasyOnboardCustomFlow = React.lazy(() =>
  import('./EasyOnboard/CustomFlow'),
);
const EasyOnboardUpdateFlow = React.lazy(() =>
  import('./EasyOnboard/UpdateFlow'),
);
const Verifications = React.lazy(() => import('./Verifications'));
const PendingVerifications = React.lazy(() =>
  import('./Verifications/PendingVerifications'),
);
const VerificationsAddress = React.lazy(() =>
  import('./Verifications/Address'),
);
const VerificationsAmlCheck = React.lazy(() =>
  import('./Verifications/AmlCheck'),
);
const VerificationsBiodata = React.lazy(() =>
  import('./Verifications/Biodata'),
);
const VerificationsIpDeviceCheck = React.lazy(() =>
  import('./Verifications/IpDeviceCheck'),
);
const LinkAccounts = React.lazy(() => import('./LinkAccounts'));
const SettingsProfile = React.lazy(() => import('./Settings/Profile'));
const DevelopersApiLogs = React.lazy(() => import('./Developers/ApiLogs'));
const DevelopersWebhook = React.lazy(() => import('./Developers/Webhook'));
const DevelopersWebhookDetails = React.lazy(() =>
  import('./Developers/WebhookDetails'),
);
const DevelopersConfiguration = React.lazy(() =>
  import('./Developers/Configuration'),
);
const SettingsTeam = React.lazy(() => import('./Settings/Team'));
const SettingsCompliance = React.lazy(() =>
  import('./Settings/Compliance'),
);
const SettingsBilling = React.lazy(() => import('./Settings/Billing'));
const SettingsAuditLogs = React.lazy(() =>
  import('./Settings/AuditLogs'),
);
const SettingsOrganisation = React.lazy(() =>
  import('./Settings/Organisation'),
);
const SettingsTeamOwner = React.lazy(() =>
  import('./Settings/Team/Owner'),
);
const SettingsTeamLayout = React.lazy(() =>
  import('./Settings/Team/Layout'),
);
const SettingsBillingPricing = React.lazy(() =>
  import('./Settings/Billing/BillingsTransactions'),
);
const FailedGoogleLogin = React.lazy(() =>
  import('../components/AcountNotFound'),
);
const AddressVerification = React.lazy(() =>
  import('./AddressVerification'),
);
const BatchAddressVerification = React.lazy(() =>
  import('./AddressVerification/BatchUpload'),
);
const IndividualSingleLookup = React.lazy(() =>
  import('./EasyLookup/IndividualLookup/SingleLookup'),
);
const IndividualBatchLookup = React.lazy(() =>
  import('./EasyLookup/IndividualLookup/BatchLookup'),
);
const BusinessLookup = React.lazy(() =>
  import('./EasyLookup/BusinessLookup'),
);
const BusinessSingleLookup = React.lazy(() =>
  import('./EasyLookup/BusinessLookup/SingleLookup'),
);
const BusinessBatchLookup = React.lazy(() =>
  import('./EasyLookup/BusinessLookup/BatchLookup'),
);
const ApiTokens = React.lazy(() => import('./Developers/ApiTokens'));
const GlobalSearchResults = React.lazy(() =>
  import('./EasyLookup/GlobalSearchResults'),
);
const ApiStatus = React.lazy(() => import('./ApiStatus'));
const EasyCreditCheck = React.lazy(() => import('./EasyCreditCheck'));
const EasyCreditCheckSummary = React.lazy(() =>
  import('./EasyCreditCheck/CreditSummary'),
);
const EasyCreditAffordability = React.lazy(() =>
  import('./EasyCreditCheck/Affordability'),
);
const EasyCreditAmlScreening = React.lazy(() =>
  import('./EasyCreditCheck/AmlScreening'),
);
const EasyCreditBehaviouralAnalysis = React.lazy(() =>
  import('./EasyCreditCheck/BehaviouralAnalysis'),
);
const EasyCreditKycInformation = React.lazy(() =>
  import('./EasyCreditCheck/KycInformation'),
);
const ApiReport = React.lazy(() => import('./Report/ApiReport'));
const EasyDetectReport = React.lazy(() =>
  import('./Report/EasyDetectReport'),
);
const AmlUserScreening = React.lazy(() =>
  import('./AMLScreening/UserScreening'),
);
const AmlBusinessScreening = React.lazy(() =>
  import('./AMLScreening/BusinessScreening'),
);
const AmlUserScreeningSingle = React.lazy(() =>
  import('./AMLScreening/UserScreening/SingleScreening'),
);
const AmlSearchResults = React.lazy(() =>
  import('./AMLScreening/SearchResults'),
);
const AmlUserScreeningBatch = React.lazy(() =>
  import('./AMLScreening/UserScreening/BatchScreening'),
);

const Customer360GovernmentLookup = React.lazy(() =>
  import('./Customer360/GovernmentLookup'),
);
const Customer360IpDeviceInfo = React.lazy(() =>
  import('./Customer360/IPDeviceInfo'),
);
const Customer360LivenessCheck = React.lazy(() =>
  import('./Customer360/LivenessCheck'),
);
const Customer360ValidationInfo = React.lazy(() =>
  import('./Customer360/ValidationInfo'),
);
const Customer360GovernmentID = React.lazy(() =>
  import('./Customer360/GovernmentID'),
);
const Customer360AddressInfo = React.lazy(() =>
  import('./Customer360/AddressInfo'),
);
const Customer360AmlCheck = React.lazy(() =>
  import('./Customer360/AmlCheck'),
);
const DocumentAnalysis = React.lazy(() => import('./DocumentAnalysis'));
const SingleDocumentAnalysis = React.lazy(() =>
  import('./DocumentAnalysis/SingleAnalysis'),
);
const MessagingReport = React.lazy(() =>
  import('./Report/MessagingReport'),
);
const AmlBusinessScreeningSingle = React.lazy(() =>
  import('./AMLScreening/BusinessScreening/SingleScreening'),
);
const Business360 = React.lazy(() => import('./Business360'));
const Business360BusinessLookup = React.lazy(() =>
  import('./Business360/BusinessLookup'),
);
const Business360BusinessId = React.lazy(() =>
  import('./Business360/BusinessID'),
);
const Business360AmlSearch = React.lazy(() =>
  import('./Business360/AmlSearch'),
);
const Business360DirectorInfo = React.lazy(() =>
  import('./Business360/DirectorInfo'),
);
const ProjectOverview = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Projects/ProjectOverview'),
);
const ProjectAccounts = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Projects/ProjectAccounts'),
);
const Projects = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Projects'),
);
const ProjectTransactions = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Projects/ProjectTransactions'),
);
const ProjectReconciliation = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Projects/ProjectReconciliation'),
);
const ProjectCustomers = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Projects/ProjectCustomers'),
);
const ProjectSettings = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Projects/ProjectSettings'),
);
const Overview = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Overview'),
);
const Transactions = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Transactions'),
);
const Reconciliation = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Reconciliation'),
);
const Customers = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Customers'),
);
const CustomerDetails = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Customers/CustomerDetails'),
);
const ProjectAccountDetails = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Projects/ProjectAccountDetails'),
);
const VerificationAnalytics = React.lazy(() =>
  import('./Verifications/VerificationAnalytics'),
);
const Signup = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Auth/Signup'),
);
const ReconciloSignIn = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Auth/ReconciloSignIn'),
);
const ForgotPassword = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Auth/ForgotPassword'),
);
const SetPassword = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Auth/SetPassword'),
);
const ResetPassword = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Auth/ResetPassword'),
);
const GoogleSignup = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Auth/GoogleSignup'),
);
const Billing = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Billing'),
);
const BillingPaymentHistory = React.lazy(() =>
  import('./FraudDetection/Reconciliation/BillingPaymentHistory'),
);
const Index = React.lazy(() => import('./FraudDetection/Baas'));
const BaasTransactions = React.lazy(() =>
  import('./FraudDetection/Baas/BaasTransactions'),
);
const BaasWallets = React.lazy(() =>
  import('./FraudDetection/Baas/BaasWallets'),
);
const BaasPayouts = React.lazy(() =>
  import('./FraudDetection/Baas/BaasPayouts'),
);
const BaasSettings = React.lazy(() =>
  import('./FraudDetection/Baas/BaasSettings'),
);
const BaasAccountDetails = React.lazy(() =>
  import('./FraudDetection/Baas/BaasAccountDetails'),
);
const AuthenticationAnalytics = React.lazy(() =>
  import('./EasyAuthentication/AuthenticationAnalytics'),
);
const AuthenticationCustomers = React.lazy(() =>
  import('./EasyAuthentication/AuthenticationCustomers'),
);
const Authentications = React.lazy(() =>
  import('./EasyAuthentication/Authentications'),
);
const Bio = React.lazy(() =>
  import('./EasyAuthentication/Authentications/Bio'),
);
const IpDeviceCheck = React.lazy(() =>
  import('./EasyAuthentication/Authentications/IpDeviceCheck'),
);
const BehavioralScore = React.lazy(() =>
  import('./EasyAuthentication/Authentications/BehavioralScore'),
);
const AuthenticationFlow = React.lazy(() =>
  import('./EasyAuthentication/AuthenticationFlow'),
);
const CreateAuthFlow = React.lazy(() =>
  import('./EasyAuthentication/AuthenticationFlow/CreateAuthFlow'),
);
const UpdateAuthFlow = React.lazy(() =>
  import('./EasyAuthentication/AuthenticationFlow/UpdateAuthFlow'),
);
const OnboardingRedirect = React.lazy(() =>
  import('./FraudDetection/Reconciliation/Auth/OnboardingRedirect'),
);
const IndividualAccounts = React.lazy(() =>
  import('./FraudDetection/Flows/Cases/Rules/IndividualAccounts'),
);
const CorporateAccounts = React.lazy(() =>
  import('./FraudDetection/Flows/Cases/Rules/CorporateAccounts'),
);
const BehaviouralMonitoring = React.lazy(() =>
  import('./FraudDetection/Flows/Cases/Rules/BehaviouralMonitoring'),
);
const CompanyVerification = React.lazy(() =>
  import('./Settings/CompanyVerification'),
);
const AuditLogs = React.lazy(() => import('./Logs/AuditLogs'));
const ExportLogs = React.lazy(() => import('./Logs/ExportLogs'));
const BaasCustomers = React.lazy(() =>
  import('./FraudDetection/Baas/customers/Index'),
);
const CustomerTransactions = React.lazy(() =>
  import('./FraudDetection/Baas/customers/components/CustomerTransactions'),
);
const CustomerWallets = React.lazy(() =>
  import('./FraudDetection/Baas/customers/components/CustomerWallets'),
);
const CustomerCards = React.lazy(() =>
  import('./FraudDetection/Baas/customers/components/CustomerCards'),
);
const CustomerCardDetails = React.lazy(() =>
  import('./FraudDetection/Baas/customers/CustomerCardDetails'),
);
const CustomerWalletDetails = React.lazy(() =>
  import('./FraudDetection/Baas/customers/CustomerWalletDetails'),
);
const UpdatedEditProcess = React.lazy(() =>
  import('./FraudDetection/Flows/UpdatedEditProcess'),
);
const FLowVersionRules = React.lazy(() =>
  import('./FraudDetection/Flows/UpdatedEditProcess/VersionRules'),
);
const FlowsAccountIndex = React.lazy(() =>
  import('./FraudDetection/Flows/Accounts'),
);
const SingleAccount = React.lazy(() =>
  import('./FraudDetection/Flows/Accounts/singleAccount'),
);
const SingleAccountEvents = React.lazy(() =>
  import('./FraudDetection/Flows/Accounts/singleAccount/Events'),
);
const SingleAccountCases = React.lazy(() =>
  import('./FraudDetection/Flows/Accounts/singleAccount/Cases'),
);
const BehaviouralAnalysis = React.lazy(() =>
  import('./FraudDetection/Flows/Events/BehaviouralAnalysis'),
);
const AMLScreeningNew = React.lazy(() =>
  import('./AMLScreening/AMLScreeningNew'),
);
const AMLScreeningResults = React.lazy(() =>
  import('./AMLScreening/AMLScreeningResults'),
);
const AMLScreeningSingleResult = React.lazy(() =>
  import('./AMLScreening/AMLScreeningSingleResult'),
);
const EmailNotifications = React.lazy(() =>
  import('./Settings/EmailNotifications'),
);
const FlowTemplates = React.lazy(() =>
  import('./FraudDetection/Flows/FlowTemplates/Index'),
);
const FlowTemplateDetails = React.lazy(() =>
  import('./FraudDetection/Flows/FlowTemplates/FlowTemplateDetails'),
);
const AllAccounts = React.lazy(() =>
  import('./FraudDetection/Flows/Accounts/AllAccounts'),
);
const VeldroOverview = React.lazy(() => import('./Veldro/Overview'));
const VeldroBusinesses = React.lazy(() => import('./Veldro/Businesses'));
const ReportedInvoices = React.lazy(() =>
  import('./Veldro/ReportedInvoices'),
);
const VeldroSingleBusiness = React.lazy(() =>
  import('./Veldro/SingleBusiness'),
);
const SentInvoices = React.lazy(() => import('./Veldro/SentInvoices'));
const ReceivedInvoices = React.lazy(() =>
  import('./Veldro/ReceivedInvoices'),
);
const ProfiledRiskOverview = React.lazy(() =>
  import('./ProfiledRisk/Overview'),
);
const ProfiledRiskProfiles = React.lazy(() =>
  import('./ProfiledRisk/Profiles'),
);
const ProfileRiskDetails = React.lazy(() =>
  import('./ProfiledRisk/ProfileDetails'),
);
const ApiAnalysis = React.lazy(() => import('./ApiAnalysis/Index'));
const ProfiledRiskBillings = React.lazy(() =>
  import('./ProfiledRisk/Billings'),
);
const ProfiledRiskUpgrade = React.lazy(() =>
  import('./ProfiledRisk/Billings/Upgrade'),
);
const Configuration = React.lazy(() =>
  import('./ProfiledRisk/Settings/Configuration'),
);
const EventAlerts = React.lazy(() =>
  import('./FraudDetection/Flows/Events/EventAlerts'),
);
const CaseAlerts = React.lazy(() =>
  import('./FraudDetection/Flows/Cases/CaseAlerts'),
);
const Support = React.lazy(() => import('./Support'));

const baseRoutes = {
  private: [
    {
      component: <Dashboard />,
      exact: true,
      path: Constants.PAGES_URL.DASHBOARD,
    },

    {
      component: <QuickActions />,
      exact: true,
      path: Constants.PAGES_URL.QUICKACTIONS,
    },
    {
      component: <QuickActionsExisting />,
      exact: true,
      path: Constants.PAGES_URL.QUICKACTIONS_EXISTING,
    },
    {
      component: <EasyLookup />,
      exact: true,
      path: Constants.PAGES_URL.EASY_LOOKUP,
    },
    {
      component: <AMLScreening />,
      exact: true,
      path: Constants.PAGES_URL.AML_SCREENING_OLD,
    },
    {
      component: <AuthenticationCustomers />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATION_CUSTOMERS,
    },
    {
      component: <Authentications />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATIONS,
    },
    {
      component: <Bio />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATIONS_BIO_DATA,
    },
    {
      component: <IpDeviceCheck />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATIONS_IP_DEVICE_CHECK,
    },
    {
      component: <BehavioralScore />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATIONS_BEHAVIORAL_SCORE,
    },
    {
      component: <AuthenticationAnalytics />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATION_ANALYTICS,
    },
    {
      component: <AuthenticationFlow />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATION_FLOW,
    },
    {
      component: <CreateAuthFlow />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATION_FLOW_CUSTOM,
    },
    {
      component: <UpdateAuthFlow />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATION_FLOW_UPDATE,
    },
    {
      component: <IndividualLookup />,
      exact: true,
      path: Constants.PAGES_URL.INDIVIDUAL_LOOKUP,
    },
    {
      component: <EmailNotifications />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_EMAIL_NOTIFICATIONS,
    },
    {
      component: <ProfiledRiskOverview />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_OVERVIEW,
    },
    {
      component: <ProfiledRiskBillings />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_TRANSACTIONS,
    },
    {
      component: <Configuration />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_CONFIGURATION,
    },
    {
      component: <FraudDetectionFlowsEvents />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_EVENTS,
    },
    {
      component: <ProfiledRiskUpgrade />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_UPGRADE,
    },
    {
      component: <ProfiledRiskProfiles />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_PROFILES,
    },
    {
      component: <ProfileRiskDetails />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_PROFILE_DETAILS,
    },
    {
      component: <IndividualSingleLookup />,
      exact: true,
      path: Constants.PAGES_URL.INDIVIDUAL_LOOKUP_SINGLE,
    },
    {
      component: <IndividualBatchLookup />,
      exact: true,
      path: Constants.PAGES_URL.INDIVIDUAL_LOOKUP_BATCH,
    },
    {
      component: <BusinessLookup />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_LOOKUP,
    },
    {
      component: <BusinessSingleLookup />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_LOOKUP_SINGLE,
    },
    {
      component: <BusinessBatchLookup />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_LOOKUP_BATCH,
    },
    {
      component: <EasyConnect />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CONNECT,
    },

    {
      component: <EasyOnboard />,
      exact: true,
      path: Constants.PAGES_URL.EASY_ONBOARD,
    },
    {
      component: <EasyOnboardCreateFlow />,
      exact: true,
      path: Constants.PAGES_URL.EASY_ONBOARD_CREATE_FLOW,
    },
    {
      component: <EasyOnboardCustomFlow />,
      exact: true,
      path: Constants.PAGES_URL.EASY_ONBOARD_CUSTOM_FLOW,
    },
    {
      component: <EasyOnboardUpdateFlow />,
      exact: true,
      path: Constants.PAGES_URL.EASY_ONBOARD_UPDATE_FLOW,
    },
    {
      component: <FraudDetectionOverview />,
      exact: true,
      path: Constants.PAGES_URL.OVERVIEW,
    },
    {
      component: <AuditLogs />,
      exact: true,
      path: Constants.PAGES_URL.AUDIT_LOGS,
    },
    {
      component: <ExportLogs />,
      exact: true,
      path: Constants.PAGES_URL.EXPORT_LOGS,
    },
    {
      component: <VeldroOverview />,
      exact: true,
      path: Constants.PAGES_URL.VELDRO_OVERVIEW,
    },
    {
      component: <VeldroBusinesses />,
      exact: true,
      path: Constants.PAGES_URL.VELDRO_BUSINESSES,
    },
    {
      component: <VeldroSingleBusiness />,
      exact: true,
      path: Constants.PAGES_URL.VELDRO_SINGLE_BUSINESS,
    },
    {
      component: <SentInvoices />,
      exact: true,
      path: Constants.PAGES_URL.VELDRO_SENT_INVOICES,
    },
    {
      component: <ReceivedInvoices />,
      exact: true,
      path: Constants.PAGES_URL.VELDRO_RECEIVED_INVOICES,
    },
    {
      component: <ReportedInvoices />,
      exact: true,
      path: Constants.PAGES_URL.VELDRO_REPORTED_INVOICES,
    },
    {
      component: <CustomLists />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOM_LISTS,
    },
    {
      component: <CustomListsItems />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOM_LISTS_ITEMS,
    },
    {
      component: <FraudDetectionOverviewPendingCases />,
      exact: true,
      path: Constants.PAGES_URL.OVERVIEW_PENDING_CASES,
    },
    {
      component: <FraudDetectionFlows />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS,
    },
    {
      component: <FraudDetectionFlowsAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ANALYTICS,
    },
    {
      component: <IndividualAccounts />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES_INDIVIDUAL,
    },
    {
      component: <CorporateAccounts />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES_CORPORATE,
    },
    {
      component: <BehaviouralMonitoring />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES_BEHAVIOURAL_MONITORING,
    },
    {
      component: <AMLScreeningResult />,
      exact: true,
      path: Constants.PAGES_URL.AML_SCREENING_RESULT,
    },
    {
      component: <AMLScreeningResults />,
      exact: true,
      path: Constants.PAGES_URL.AML_SCREENING_RESULTS,
    },
    {
      component: <AMLScreeningSingleResult />,
      exact: true,
      path: Constants.PAGES_URL.AML_SCREENING_SINGLE_RESULT,
    },

    {
      component: <ProjectOverview />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_OVERVIEW,
    },
    {
      component: <ProjectReconciliation />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_RECONCILIATION,
    },

    {
      component: <ProjectCustomers />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_CUSTOMERS,
    },
    {
      component: <ProjectSettings />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_SETTINGS,
    },
    {
      component: <ProjectTransactions />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_TRANSACTIONS,
    },
    {
      component: <ProjectAccounts />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_ACCOUNTS,
    },
    {
      component: <ProjectAccountDetails />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_ACCOUNTS_DETAILS,
    },
    {
      component: <Projects />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_PROJECTS,
    },
    {
      component: <Overview />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_OVERVIEW,
    },
    {
      component: <Transactions />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_TRANSACTIONS,
    },
    {
      component: <Reconciliation />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION,
    },
    {
      component: <Customers />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_CUSTOMERS,
    },
    {
      component: <Support />,
      exact: true,
      path: Constants.PAGES_URL.SUPPORT,
    },
    {
      component: <CustomerDetails />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_CUSTOMER_DETAILS,
    },

    {
      component: <FraudDetectionFlowsEventDetails />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_EVENT_DETAILS,
    },
    {
      component: <FraudDetectionFlowsEventEvaluationResult />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_EVENT_RESULT_EVALUATION,
    },
    {
      component: <BehaviouralAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_EVENT_BEHAVIOURAL_ANALYSIS,
    },
    {
      component: <EventAlerts />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_EVENT_ALERT,
    },
    {
      component: <CaseAlerts />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASE_ALERT,
    },
    {
      component: <FraudDetectionFlowsCases />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES,
    },
    {
      component: <FraudDetectionFlowsCasesDetails />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES_DETAILS,
    },
    {
      component: <FraudDetectionFlowsCasesDetails />,
      exact: true,
      path: Constants.PAGES_URL.PENDING_CASES_DETAILS,
    },
    {
      component: <FraudDetectionFlowsBehaviouralAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES_BEHAVIOURAL_ANALYSIS,
    },
    {
      component: <FraudDetectionFlowsSupportingDoc />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES_SUPPORTING_DOC,
    },
    {
      component: <FraudDetectionFlowsEvents />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_EVENTS,
    },
    {
      component: <FraudDetectionFlowsAccount />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ACCOUNT,
    },
    {
      component: <FlowsAccountIndex />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ACCOUNTS,
    },
    {
      component: <AllAccounts />,
      exact: true,
      path: Constants.PAGES_URL.ACCOUNTS,
    },
    {
      component: <SingleAccount />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ACCOUNTS_OVERVIEW,
    },
    {
      component: <SingleAccountEvents />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ACCOUNTS_EVENTS,
    },
    {
      component: <SingleAccountCases />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ACCOUNTS_CASES,
    },
    {
      component: <FraudDetectionFlowsAccountTransactions />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ACCOUNT_TRANSACTIONS,
    },
    {
      component: <FraudDetectionFlowsSettings />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_SETTINGS,
    },
    {
      component: <UpdatedEditProcess />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_EDIT_PROCESS,
    },
    {
      component: <FLowVersionRules />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_VERSION_RULES,
    },
    {
      component: <FlowTemplates />,
      exact: true,
      path: Constants.PAGES_URL.FLOW_TEMPLATES,
    },
    {
      component: <FlowTemplateDetails />,
      exact: true,
      path: Constants.PAGES_URL.FLOW_TEMPLATE_DETAILS,
    },
    {
      component: <UpdatedEditProcess />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_UPDATED_EDIT_PROCESS,
    },
    {
      component: <Verifications />,
      exact: true,
      path: Constants.PAGES_URL.VERIFICATIONS,
    },
    {
      component: <VerificationAnalytics />,
      exact: true,
      path: Constants.PAGES_URL.VERIFICATION_ANALYTICS,
    },
    {
      component: <PendingVerifications />,
      exact: true,
      path: Constants.PAGES_URL.PENDING_VERIFICATIONS,
    },
    {
      component: <VerificationsAddress />,
      exact: true,
      path: Constants.PAGES_URL.VERIFICATIONS_ADDRESS,
    },
    {
      component: <VerificationsAmlCheck />,
      exact: true,
      path: Constants.PAGES_URL.VERIFICATIONS_AML_CHECK,
    },
    {
      component: <VerificationsBiodata />,
      exact: true,
      path: Constants.PAGES_URL.VERIFICATIONS_BIO_DATA,
    },
    {
      component: <VerificationsIpDeviceCheck />,
      exact: true,
      path: Constants.PAGES_URL.VERIFICATIONS_IP_DEVICE_CHECK,
    },
    {
      component: <LinkAccounts />,
      exact: true,
      path: Constants.PAGES_URL.LINK_ACCOUNTS,
    },
    {
      component: <DevelopersApiLogs />,
      exact: true,
      path: Constants.PAGES_URL.DEVELOPERS_API_LOGS,
    },
    {
      component: <DevelopersWebhook />,
      exact: true,
      path: Constants.PAGES_URL.DEVELOPERS_WEBHOOK,
    },
    {
      component: <ApiAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.API_ANALYSIS,
    },
    {
      component: <ApiStatus />,
      exact: true,
      path: Constants.PAGES_URL.API_STATUS,
    },
    {
      component: <DevelopersWebhookDetails />,
      exact: true,
      path: Constants.PAGES_URL.DEVELOPERS_WEBHOOK_DETAILS,
    },
    {
      component: <DevelopersConfiguration />,
      exact: true,
      path: Constants.PAGES_URL.DEVELOPERS_CONFIGURATION,
    },
    {
      component: <SettingsProfile />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_PROFILE,
    },
    {
      component: <SettingsCompliance />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_COMPLIANCE,
    },
    {
      component: <SettingsTeam />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_TEAM,
    },
    {
      component: <SettingsTeamOwner />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_TEAM_OWNER,
    },
    {
      component: <SettingsAuditLogs />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_AUDIT_LOGS,
    },
    {
      component: <SettingsOrganisation />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_ORGANISATION,
    },
    {
      component: <SettingsBilling />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_BILLING,
    },
    {
      component: <SettingsBillingPricing />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_BILLING_PRICING,
    },
    {
      component: <SettingsTeamLayout />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_TEAM_LAYOUT,
    },
    {
      component: <AddressVerification />,
      exact: true,
      path: Constants.PAGES_URL.ADDRESS_VERIFICATION,
    },
    {
      component: <CompanyVerification />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_COMPANY_VERIFICATION,
    },
    {
      component: <BatchAddressVerification />,
      exact: true,
      path: Constants.PAGES_URL.BATCH_ADDRESS_VERIFICATION,
    },
    {
      component: <ApiTokens />,
      exact: true,
      path: Constants.PAGES_URL.API_TOKENS,
    },
    {
      component: <GlobalSearchResults />,
      exact: true,
      path: Constants.PAGES_URL.GLOBAL_SEARCH_RESULTS,
    },
    {
      component: <EasyCreditCheck />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CREDIT_CHECK,
    },
    {
      component: <EasyCreditCheckSummary />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CREDIT_CREDIT_SUMMARY,
    },
    {
      component: <EasyCreditAffordability />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CREDIT_AFFORDABILITY,
    },
    {
      component: <EasyCreditAmlScreening />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CREDIT_AML_SCREENING,
    },
    {
      component: <EasyCreditBehaviouralAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CREDIT_BEHAVIOURAL_ANALYSIS,
    },
    {
      component: <EasyCreditKycInformation />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CREDIT_KYC_INFORMATION,
    },
    {
      component: <ApiReport />,
      exact: true,
      path: Constants.PAGES_URL.API_REPORT,
    },
    {
      component: <EasyDetectReport />,
      exact: true,
      path: Constants.PAGES_URL.EASY_DETECT_REPORT,
    },
    {
      component: <AmlUserScreening />,
      exact: true,
      path: Constants.PAGES_URL.AML_USER_SCREENING,
    },
    {
      component: <AMLScreeningNew />,
      exact: true,
      path: Constants.PAGES_URL.AML_SCREENING,
    },
    {
      component: <AmlUserScreeningSingle />,
      exact: true,
      path: Constants.PAGES_URL.AML_USER_SCREENING_SINGLE,
    },
    {
      component: <AmlUserScreeningBatch />,
      exact: true,
      path: Constants.PAGES_URL.AML_USER_SCREENING_BATCH,
    },
    {
      component: <AmlBusinessScreening />,
      exact: true,
      path: Constants.PAGES_URL.AML_BUSINESS_SCREENING,
    },
    {
      component: <AmlSearchResults />,
      exact: true,
      path: Constants.PAGES_URL.AML_USER_SCREENING_SEARCH_RESULTS,
    },
    {
      component: <AmlSearchResults />,
      exact: true,
      path: Constants.PAGES_URL.AML_BUSINESS_SCREENING_SEARCH_RESULTS,
    },
    {
      component: <Customer360 />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360,
    },
    {
      component: <Customer360GovernmentLookup />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_GOVT_LOOKUP,
    },
    {
      component: <Customer360IpDeviceInfo />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_IP_DEVICE_INFO,
    },
    {
      component: <Customer360LivenessCheck />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_LIVENESS_CHECK,
    },
    {
      component: <Customer360ValidationInfo />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_VALIDATION_INFO,
    },
    {
      component: <Customer360GovernmentID />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_GOVT_ID,
    },
    {
      component: <Customer360AddressInfo />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_ADDRESS_INFO,
    },
    {
      component: <Customer360AmlCheck />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_AML_CHECK,
    },
    {
      component: <DocumentAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.DOCUMENT_ANALYSIS,
    },
    {
      component: <SingleDocumentAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.DOCUMENT_ANALYSIS_SINGLE,
    },
    {
      component: <MessagingReport />,
      exact: true,
      path: Constants.PAGES_URL.MESSAGING_REPORT,
    },
    {
      component: <AmlBusinessScreeningSingle />,
      exact: true,
      path: Constants.PAGES_URL.AML_BUSINESS_SCREENING_SINGLE,
    },
    {
      component: <Business360 />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_360,
    },
    {
      component: <Business360BusinessLookup />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_360_BUSINESS_LOOKUP,
    },
    {
      component: <Business360BusinessId />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_360_BUSINESS_ID,
    },
    {
      component: <Business360AmlSearch />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_360_AML_SEARCH,
    },
    {
      component: <Business360DirectorInfo />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_360_DIRECTOR_INFO,
    },
    {
      component: <Billing />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_BILLING,
    },
    {
      component: <BillingPaymentHistory />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_BILLING_HISTORY,
    },
    {
      component: <Index />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_OVERVIEW,
    },
    {
      component: <BaasTransactions />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_TRANSACTIONS,
    },
    {
      component: <BaasWallets />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_WALLETS,
    },
    {
      component: <BaasPayouts />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_PAYOUTS,
    },
    {
      component: <BaasSettings />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_SETTINGS,
    },
    {
      component: <BaasCustomers />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_CUSTOMERS,
    },
    {
      component: <CustomerTransactions />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_CUSTOMERS_TRANSACTIONS,
    },
    {
      component: <CustomerWallets />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_CUSTOMERS_WALLETS,
    },
    {
      component: <CustomerCards />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_CUSTOMERS_CARDS,
    },
    {
      component: <CustomerCardDetails />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_CUSTOMERS_CARD_DETAILS,
    },
    {
      component: <CustomerWalletDetails />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_CUSTOMERS_WALLET_DETAILS,
    },
    {
      component: <BaasAccountDetails />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_ACCOUNT_DETAIL,
    },
  ],
  public: [
    {
      component: <Signin />,
      exact: true,
      path: Constants.PAGES_URL.SIGNIN,
    },

    {
      component: <GoogleSignup />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_GOOGLE_SIGN_UP,
    },

    {
      component: <ForgotPasswordUser />,
      exact: true,
      path: Constants.PAGES_URL.FORGOT_PASSWORD,
    },
    {
      component: <ResetPasswordUser />,
      exact: true,
      path: Constants.PAGES_URL.RESET_PASSWORD,
    },
    {
      component: <OnboardingRedirect />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_REDIRECT,
    },
    {
      component: <Team />,
      exact: true,
      path: Constants.PAGES_URL.TEAM,
    },
    {
      component: <CreatePasswordUser />,
      exact: true,
      path: Constants.PAGES_URL.CREATE_PASSWORD,
    },
    {
      component: <FailedGoogleLogin />,
      exact: true,
      path: Constants.PAGES_URL.ACCOUNT_NOT_FOUND,
    },
    {
      component: <GoogleSignUpComplete />,
      exact: true,
      path: '/',
    },
    {
      component: <Signup />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_SIGNUP,
    },
    {
      component: <ReconciloSignIn />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_SIGNIN,
    },
    {
      component: <ForgotPassword />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_FORGOT_PASSWORD,
    },
    {
      component: <SetPassword />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_SET_PASSWORD,
    },
    {
      component: <ResetPassword />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_RESET_PASSWORD,
    },
  ],
};

export default baseRoutes;
